import styled from "styled-components";
import { defaultBreakpoints } from "styled-media-query";

export const BlockQuoteText = styled.div`
  margin: 0;
  border-left: 3px solid ${(props) => props.theme.default.color.primary};
  blockquote {
    margin: 0;
    margin-left: 17px;
  }
  p {
    font-family: ${({ theme }) => theme.default.fontFamily.secondaryFont};
    font-size: 25px;
    font-style: normal;
    font-weight: 400;
    line-height: 38px;
    letter-spacing: 0em;
    text-align: left;
    margin: 0;
    color: ${(props) => props.theme.default.color.text.dark};
    @media (max-width: ${defaultBreakpoints.medium}) {
      font-size: 36px;
      line-height: 54px;
      margin: 30px 0 17px;
    }
  }
`;

export const Quote = styled.h1`
  font-size: 80px;
  font-style: italic;
  font-weight: 700;
  line-height: 30px;
  letter-spacing: 0em;
  text-align: left;
  margin: 0;
  margin-top: 48px;
  color: ${(props) => props.theme.default.color.primary};
`;

export const Cite = styled.p`
  font-family:  ${({ theme }) => theme.default.fontFamily.secondaryFont};
  font-size: 20px;
  font-style: italic;
  font-weight: 700;
  line-height: 30px;
  letter-spacing: 0em;
  text-align: left;
  color: ${(props) => props.theme.default.color.primary};
`;
